import { Star } from 'lucide-react';

import { cn } from '@/lib/utils';

type Props = {
  starred: boolean;
  busy?: boolean;
  disabled?: boolean;
  size?: 'sm' | 'md';
  className?: string;
  ariaLabel: string;
  onToggle: (e: React.MouseEvent) => void;
};

export function ApplicationStarButton({
  starred,
  busy = false,
  disabled = false,
  size = 'sm',
  className,
  ariaLabel,
  onToggle,
}: Props) {
  const iconSize = size === 'md' ? 'h-5 w-5' : 'h-4 w-4';

  return (
    <button
      type="button"
      aria-label={ariaLabel}
      aria-pressed={starred}
      disabled={disabled || busy}
      onClick={onToggle}
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-md transition-colors',
        size === 'md' ? 'h-8 w-8' : 'h-7 w-7',
        starred
          ? 'text-amber-500 hover:text-amber-600'
          : 'text-muted-foreground/40 hover:text-amber-500',
        disabled && 'opacity-50 pointer-events-none',
        className,
      )}
    >
      <Star
        className={cn(iconSize, starred && 'fill-current')}
      />
    </button>
  );
}
